import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {PATHS} from "@/constants/routes";
import {LoginPage} from "@/pages/auth/Login";
import {useAuthStore} from "@/store/auth.store";

/**
 * Route-level wrapper for the new `LoginPage` slice.
 * Centers the page on a dark brand background and redirects authenticated
 * users to `PATHS.home`. Keeps the presentational component pristine.
 */
const LoginRoute = () => {
  const navigate = useNavigate();
  const status = useAuthStore(state => state.status);
  const hydrate = useAuthStore(state => state.hydrate);

  useEffect(() => {
    if (status === "checking") hydrate();
  }, [status, hydrate]);

  useEffect(() => {
    if (status === "authenticated") navigate(PATHS.home, {replace: true});
  }, [status, navigate]);

  return (
    <main className="flex min-h-screen w-full items-center justify-center bg-[var(--color-bg)] px-4 py-8">
      <LoginPage onSuccess={() => navigate(PATHS.home, {replace: true})} />
    </main>
  );
};

export default LoginRoute;
